export default function Input(props) {
  return (
    <input
      {...props}
      className={
        "w-full rounded-2xl bg-white border border-gray-300 px-4 py-4 text-gray-900 placeholder:text-gray-400 " +
        "focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
      }
    />
  );
}
